/**
 * 폴링 간격 상수 (밀리초).
 * 각 컴포넌트에서 setInterval에 사용. 단일 출처로 관리하여 일관성 확보.
 */
export const POLLING_INTERVALS = {
  NOTIFICATIONS: 30000,        // NotificationBell 미확인 알림 카운트
  ADMIN_DASHBOARD: 30000,      // Admin 대시보드 헬스/통계
  TASK_LOGS: 10000,            // 진행 중인 작업 상태
  RATE_LIMIT_MONITORING: 30000,// API rate limit 모니터링
  MARKET_STATUS: 15000,        // 시장 상태 위젯 (WIDGET.SETTINGS.market_status.refreshInterval과 일치)
};
